import styled from '@emotion/styled'

import { Attribute, Currency, DateDisplay, Space } from '../../../../../../components/core-v2'
import { FundingSource, TermsStepState } from '../../../02-terms/state/terms-slice'
import { AssetSummaryItem } from '../../../03-portfolio/types'
import { ApprovalBox } from '../../molecules/approval-box'
import { ConfirmationBox } from '../../molecules/confirmation-box'
import { ApprovalProps } from './types'

type ApproveTermsProps = ApprovalProps & {
  assetSummary?: AssetSummaryItem[]
  isApproved: boolean
  terms: TermsStepState
}

const Hr = styled.div`
  border-top: 1px solid var(--White90);
`

export const ApproveTerms = ({
  assetSummary,
  isApproved,
  onChangeIsApproved,
  onClickEdit,
  terms
}: ApproveTermsProps) => (
  <ApprovalBox isApproved={isApproved} title="Terms">
    <Attribute name="Name">{terms.terms?.accountName}</Attribute>

    {terms.terms.fundingSource === FundingSource.Cash && (
      <Attribute name="Investment amount">
        <Currency value={terms.terms?.investment} />
      </Attribute>
    )}

    {terms.terms.fundingSource === FundingSource.Transfer && (
      <>
        <Space py={3}>
          <Hr />
        </Space>
        {assetSummary.map(asset => (
          <Attribute key={asset.id} name={`${asset.name} (${asset.id})`}>
            {`${asset.units} units`}
          </Attribute>
        ))}
        <Space py={3}>
          <Hr />
        </Space>
      </>
    )}

    {terms.terms.fundingSource === FundingSource.Switch && (
      <>
        {terms.terms.fullSwitch && (
          <>
            <Attribute name="Switch out trade">{terms.terms.switchTrade?.accountName}</Attribute>
            <Attribute name="Current Value of switch out Trade">
              <Currency value={terms.terms.switchTrade?.accountValue} />
            </Attribute>
            <Attribute name="Full switch">Yes</Attribute>
          </>
        )}
        {!terms.terms.fullSwitch && (
          <>
            <Attribute name="Switch out trade">{terms.terms.switchTrade?.accountName}</Attribute>
            <Attribute name="Switch amount">
              <Currency value={terms.terms.switchInvestment} />
            </Attribute>
          </>
        )}
      </>
    )}

    <Attribute name="Start date">
      {terms.terms?.requestedStartDate ? (
        <DateDisplay value={terms.terms?.requestedStartDate} />
      ) : (
        'As soon as possible'
      )}
    </Attribute>

    <ConfirmationBox
      elementTitle="Terms"
      isApproved={isApproved}
      isAre="are"
      onChangeIsApproved={onChangeIsApproved}
      onClickEdit={onClickEdit}
    />
  </ApprovalBox>
)
